import { render, staticRenderFns } from "./loginBanner.vue?vue&type=template&id=a10c2646&scoped=true&"
import script from "./loginBanner.vue?vue&type=script&lang=js&"
export * from "./loginBanner.vue?vue&type=script&lang=js&"
import style0 from "./loginBanner.vue?vue&type=style&index=0&id=a10c2646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10c2646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
